import React from 'react';
import { withStyles } from '@mui/styles';

const style = {
    row:{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        gap: 12,
        paddingBottom: 16
    }
};

const Row = ({classes, children}) =>{
    return(
        <div className={classes.row}>
            {Array.isArray(children) 
                ?
                    children.map( (child, i) => child&&React.cloneElement(child, {key: i}))
                :
                    React.cloneElement(children)
            }
        </div>
    )
} 

export default withStyles(style)(Row);